<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div *ngIf="!$hasMissingRequiredInParams"
          class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="edit" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_edit_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized && !$hasMissingRequiredInParams">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
        </div>

        <div class="widgets">
          <div *ngIf="!widgets.licenseplate_total_packaged_amount_widget.hidden && !widgets.licenseplate_total_packaged_amount_widget.removed" class="widget-container">
            <Inventory-licenseplate_total_packaged_amount_widget
            #$widgets_licenseplate_total_packaged_amount_widget 
              [licenseplateId]="$widgets_licenseplate_total_packaged_amount_widget_inParams_licenseplateId"
            ($refreshEvent)="refresh(false, false, '$widgets_licenseplate_total_packaged_amount_widget')"
            >
            </Inventory-licenseplate_total_packaged_amount_widget>
          </div>
          <div *ngIf="!widgets.licenseplate_total_gross_weight_widget.hidden && !widgets.licenseplate_total_gross_weight_widget.removed" class="widget-container">
            <Inventory-licenseplate_total_gross_weight_widget
            #$widgets_licenseplate_total_gross_weight_widget 
              [licenseplateId]="$widgets_licenseplate_total_gross_weight_widget_inParams_licenseplateId"
            ($refreshEvent)="refresh(false, false, '$widgets_licenseplate_total_gross_weight_widget')"
            >
            </Inventory-licenseplate_total_gross_weight_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.inventory.hasTabToShow" class="tab" data-cy="tab-inventory">
              <h2 [className]="tabs.inventory.active? 'active': ''" (click)="tabs.inventory.activate()">{{tabs.inventory.title}}</h2>
            </div>
            <div *ngIf="tabs.tasks.hasTabToShow" class="tab" data-cy="tab-tasks">
              <h2 [className]="tabs.tasks.active? 'active': ''" (click)="tabs.tasks.activate()">{{tabs.tasks.title}}</h2>
            </div>
          </div>
        
              <FootPrintPortalManager-inventory_pallet_grid *ngIf="tabs.inventory.active"
              #$tabs_inventory
              [licenseplateId]="$tabs_inventory_inventory_pallet_grid_inParams_licenseplateId"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory')">
              </FootPrintPortalManager-inventory_pallet_grid>
              <FootPrintPortalManager-inventory_tasks_grid *ngIf="tabs.tasks.active"
              #$tabs_tasks
              [licenseplateId]="$tabs_tasks_inventory_tasks_grid_inParams_licenseplateId"
              ($refreshEvent)="refresh(false, false, '$tabs_tasks')">
              </FootPrintPortalManager-inventory_tasks_grid>
        </div>

      </ng-container>
      <div *ngIf="$hasMissingRequiredInParams"
           class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>